import { render, staticRenderFns } from "./DeletedFilter.vue?vue&type=template&id=383224de&scoped=true"
import script from "./DeletedFilter.vue?vue&type=script&lang=js"
export * from "./DeletedFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383224de",
  null
  
)

export default component.exports